<div class="app__container">
    <ax-page-template></ax-page-template>
</div>
